import React, { Component } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { CommonTheme } from '../styles/Styles';
import { AppTheme } from '../styles/AppTheme';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiHelper } from '../common/helpers/UiHelper';
import { EmptyMsgView } from '../components/EmptyMsgView';
import { aboutUsData } from '../Data/AppData';
import { teamData } from '../Data/AppData';
import { BreadCrumbs } from '../common/components/BreadCrumbs';
import Grid from '@material-ui/core/Grid';

export class About extends Component {

  constructor(props) {
    super(props)
    this.state = {
      fetchState: ApiHelper.State.READY,
    }
    this.breadCrumbs = [
      { title: 'Home', to: '/' },
      { title: 'About' },
    ]
  }

  componentDidMount() {
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return <EmptyMsgView msg={this.state.errMsg} />
    } else {
      return this.readyView();
    }
  }


  readyView() {
    return (
      <div className={css(Styles.container)}>
        <div className={css(Styles.bcContainer)}>
          <BreadCrumbs breadCrumbs={this.breadCrumbs} />
        </div>
        <div className={css(Styles.innerContainer)}>
          {aboutUsData.map((item, index) => {
            return (
              <div key={index}>
                <h1 className={css(Styles.title)}>{item.title}</h1>
                <p className={css(Styles.descr)}>{item.descr}</p>
              </div>
            )
          })}

          <div>
            <h1 className={css(Styles.title)}>Our Team</h1>
            <Grid container spacing={4}>
              {teamData.map((item, index) => {
                return (
                  <Grid item xs={12} sm={12}>
                    <div className={css(Styles.teamInnerContainer)}>
                      <div className={css(Styles.teamImgContainer)}>
                        <img src={item.img} className={css(Styles.imgContainer)}/>
                      </div>
                      <div className={css(Styles.teamDescContainer)}>
                        <p className={css(Styles.descContainer, Styles.name)}>{item.name}</p>
                        <p className={css(Styles.descContainer)}>{item.descr}</p>
                      </div>
                    </div>
                  </Grid>
                )})}
            </Grid>
          </div>
        </div>
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: CommonTheme.white,
    width: CommonTheme.webViewPort,
    //justifyContent: 'center',
    marginBottom: '30px',
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      width: '90%',
      //alignItems: 'center',
    },
    '@media (min-width: 768px) and (max-width: 1024px)': {
      width: CommonTheme.mobViewPort,
    },
  },
  innerContainer: {
    //marginTop: 20,
    width: '100%',
    '@media (max-width: 767px)': {
      //marginTop: 20,
    },
  },
  title: {
    color: AppTheme.primaryColor,
    fontSize: 24,
  },
  descr: {
    whiteSpace: 'pre-wrap',
  },
  bcContainer: {
    marginTop: 20,
  },

  teamInnerContainer: {
    display: 'flex',
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      alignItems: 'center'
    },
  },
  teamImgContainer: {
    // width: 800,
    // '@media (max-width: 767px)': {
    //   width: 200
    // },
  },
  imgContainer: {
    // maxHeight: '100%',
    // maxWidth: '100%',
    width: 120,
    height: 120,
    borderRadius: 10
  },
  teamDescContainer: {
    marginLeft: 10
  },
  descContainer: {
    margin: 0
  },
  name: {
    fontWeight: 'bold',
    marginBottom: 5
  }
})


// WEBPACK FOOTER //
// ./src/screens/About.js